import Cookies from 'js-cookie'
import { DateRange } from 'react-day-picker'

export const COUNTRY_DOMAINS = {
    NL: 'trustoo.nl',
    BE: 'trustlocal.be',
    DE: 'trustlocal.de',
    ES: 'trustlocal.es',
} as const

export const DOMAIN =
    COUNTRY_DOMAINS[
        (Cookies.get('_trustoo_office_country') as keyof typeof COUNTRY_DOMAINS) || 'NL'
    ]

export const ProviderTargets = {
    ALL: 'all' as const,
    BASIC: 'basic' as const,
    PREMIUM: 'premium' as const,
    SPECIFIC: 'specific' as const,
} as const

export const DeliveryTypes = {
    POP_UP: 'pop_up' as const,
    PUSH: 'push' as const,
    BOTH: 'both' as const,
} as const

export const POP_UP_NOTIFICATION = {
    TARGETS: {
        USER: ProviderTargets,
        SERVICES: {
            ALL: 'all services',
        },
    },
    STATUS: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        TRIGGERABLE: 'Triggerable',
    },
    DELIVERY_TYPE: DeliveryTypes,
} as const

export type ProviderTarget = (typeof ProviderTargets)[keyof typeof ProviderTargets]

export type DeliveryType = (typeof DeliveryTypes)[keyof typeof DeliveryTypes]

export const DELIVERY_TYPE_LABELS: Record<DeliveryType, string> = {
    [DeliveryTypes.POP_UP]: 'Pop-up',
    [DeliveryTypes.PUSH]: 'Push notification',
    [DeliveryTypes.BOTH]: 'Pop-up + push',
}

export const deliveryTypeIncludesPush = (deliveryType?: DeliveryType) =>
    deliveryType === DeliveryTypes.PUSH || deliveryType === DeliveryTypes.BOTH

export interface PopUpNotificationFolder {
    pop_up_notification_folder_id: number
    name: string
    country_code: string
}

export default interface PopUpNotification {
    id?: number
    pop_up_notification_id?: number
    country_code: 'NL' | 'BE' | 'ES' | 'DE'
    header_image?: string
    file?: {
        preview: string
        base64: string
        filename: string
    }
    title: string
    label: string
    log_count_open: number
    log_count_click: number
    push_count_sent?: number
    push_count_shown?: number
    push_count_click?: number
    content: string
    cta_button?: { name: string; url: string; target: string }
    users_target: ProviderTarget
    specific_targets: string[] | undefined
    services_target?: string[]
    availability?: DateRange
    status: 1 | 0 | 2
    delivery_type: DeliveryType
    push_title?: string | null
    push_body?: string | null
    /** UTC, as `YYYY-MM-DD HH:mm:ss`. Rendered in the country's timezone. */
    push_send_at?: string | null
    push_sent_at?: string | null
    archived?: boolean
    pop_up_notification_folder_id?: number | null
    /** Read-only, resolved by the API for the overview column. */
    folder_name?: string | null
    created?: string
    modified?: string
}
